import { render } from "./ExerciseContainer.vue?vue&type=template&id=d11a9880"
import script from "./ExerciseContainer.vue?vue&type=script&lang=js"
export * from "./ExerciseContainer.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__